import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { useSSRQuery } from '../graphql/useSSRQuery';
import gql from 'graphql-tag';

const SETTINGS = gql`
  query maxymiserSettings {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        configurations {
          maxymiserScriptLocation
          maxymiserEnabled
        }
      }
    }
  }
`;

const MaxymiserProvider = ({ children }) => {
  const { loading, error, data } = useSSRQuery(SETTINGS);

  if (loading) {
    return null;
  }
  if (error) {
    throw error;
  }
  const {
    maxymiserScriptLocation,
    maxymiserEnabled,
  } = data.application.configurations;

  return (
    <React.Fragment>
      {maxymiserEnabled && maxymiserScriptLocation ? (
        <Head>
          <script src={maxymiserScriptLocation} />
        </Head>
      ) : null}

      {children}
    </React.Fragment>
  );
};

MaxymiserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MaxymiserProvider;
